var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "questionnaire" },
    _vm._l(_vm.modelCells, function (moduleTemplate) {
      return _c("questionnaire-edit-module", {
        key: moduleTemplate.id,
        attrs: {
          config: _vm.questionnaire.config,
          model: _vm.getModel(moduleTemplate.id),
          preview: _vm.preview,
          template: moduleTemplate,
        },
        on: {
          questionAdded: _vm.$rbEmit,
          questionRemoved: _vm.$rbEmit,
          sectionAdded: _vm.$rbEmit,
          sectionRemoved: _vm.$rbEmit,
          moduleAdded: _vm.$rbEmit,
          moduleRemoved: _vm.$rbEmit,
          questionRequiredChanged: _vm.$rbEmit,
          tableAdded: _vm.$rbEmit,
          tableRemoved: _vm.$rbEmit,
          tableConfigure: _vm.$rbEmit,
          userDefinedChanged: _vm.$rbEmit,
          userDefinedRemoved: _vm.$rbEmit,
          specialsChanged: _vm.$rbEmit,
        },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }